export const num = (v: number) => Number(v).toLocaleString('ru-RU');

export const money = (v: number | null) =>
  v == null ? '—' : `${Number(v).toLocaleString('ru-RU', { maximumFractionDigits: 2 })} ₽`;
